import { makeStyles, tokens } from '@fluentui/react-components';

export const useCardFullImageLayoutStyles = makeStyles({
  fullImageBackground: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: tokens.colorBrandBackgroundInverted,
  },
});
